import {Component, EventEmitter, Output, ViewEncapsulation} from '@angular/core';
import {EmailDialogComponent} from "../email-dialog/email-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import { MaterialModule } from "src/app/app.materials";

@Component({
  selector: 'app-model-card-purchase',
  templateUrl: './model-card-purchase.component.html',
  styleUrls: ['../model-card/model-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MaterialModule],
  standalone: true,
})
export class ModelCardPurchaseComponent {
  @Output() closeEvent: EventEmitter<any>;

  constructor(
    private dialog: MatDialog
  ) {
    this.closeEvent = new EventEmitter<any>();
  }

  closeCustomPortfolioSection() {
    this.closeEvent.emit();
  }

  onClickPurchase() {
    this.dialog.open(EmailDialogComponent, {
      data: {
        type: 'purchase'
      },
      minWidth: '300px',
      maxWidth: '500px'
    });
  }
}
